import React from "react";
import "../../styles/footer.css";
import { Spring } from "react-spring/renderprops";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { displayed: false };
  }
  componentDidMount() {
    this.sto = setTimeout(() => {
      this.setState({ displayed: true });
    }, 500);
  }

  render() {
    const d = this.state.displayed;
    return (
      <>
        {d && (
          <Spring from={{ opacity: 0 }} to={{ opacity: 1 }}>
            {props => (
              <footer id="footer" className="footer" style={props}>
                <span>Developped in React</span>
              </footer>
            )}
          </Spring>
        )}
      </>
    );
  }
}

export default Footer;
